module.exports = __webpack_public_path__ + "img/labor-nothing.ccfd9ec8.png";